import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ICondition, ICreateConditionDTO } from './interfaces/condition.interface';

export const ConditionActions = createActionGroup({
  source: 'Condition',
  events: {
    'Load Conditions': emptyProps(),
    'Load Conditions Success': props<{ conditions: ICondition[] }>(),
    'Load Conditions Failure': props<{ error: unknown }>(),

    'Create Condition': props<{ dto: ICreateConditionDTO }>(),
    'Create Condition Success': props<{ condition: ICondition }>(),
    'Create Condition Failure': props<{ error: unknown }>(),

    'Update Condition': props<{ id: string; dto: Partial<ICreateConditionDTO> }>(),
    'Update Condition Success': props<{ condition: ICondition }>(),
    'Update Condition Failure': props<{ error: unknown }>(),

    'Delete Condition': props<{ id: string }>(),
    'Delete Condition Success': props<{ id: string }>(),
    'Delete Condition Failure': props<{ error: unknown }>(),
  },
});
